import Vue from 'vue'

const state = {
    lesseeList: [],
    sourceOptions: [],
    loading: false,
    error: null,
}

const mutations = {
    SET_LESSEE_LIST(state, data) {
        state.lesseeList = data
    },
    SET_SOURCE_OPTIONS(state, data) {
        state.sourceOptions = data
    },
    SET_LOADING(state, value) {
        state.loading = value
    },
    SET_ERROR(state, error) {
        state.error = error
    },
    CLEAR_ERROR(state) {
        state.error = null
    },
}

const actions = {
    async fetchLesseeList({ commit }, payload) {
        commit('SET_LOADING', true)
        commit('CLEAR_ERROR')
        try {
            // Replace with actual API endpoint
            const response = await Vue.prototype.$http.get(process.env.GET_COMPANY, {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
            })
            commit('SET_LESSEE_LIST', response.data.content || [])
            return response.data.content || []
        } catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch lessee list')
            console.error('Error fetching lessee list:', error)
            return []
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async fetchLesseeDetail({ commit }, lesseeId) {
        commit('SET_LOADING', true)
        commit('CLEAR_ERROR')
        try {
            // Replace with actual API endpoint
            const response = await Vue.prototype.$http.get(`/api/lessee/${lesseeId}`)
            commit('SET_LESSEE_DETAIL', response.data || {})
            return response.data
        } catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch lessee detail')
            console.error('Error fetching lessee detail:', error)
            return {}
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async fetchLesseeSourceOptions({ commit }) {
        try {
            const response = await Vue.prototype.$http.get(process.env.GET_LESSEE_SOURCE, {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
            })
            if (response.data.status == 400) {
                swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                });
                this.handleLogout();
            } else {
                commit('SET_SOURCE_OPTIONS', response.data.data);
                return response.data.data;
            }
        } catch (error) {
            console.error('Error fetching lessee source options:', error)
        } finally {
            commit('SET_LOADING', false)
            return null
        }
    }
}

const getters = {
    getLesseeList: (state) => state.lesseeList,
    getLoading: (state) => state.loading,
    getError: (state) => state.error,
    getLesseeListSelectOptions: (state) => {
        return state.lesseeList.map(lessee => ({
            label: lessee.companyName,
            value: lessee.companyId,
        }))
    },
    getLesseeSourceSelectOptions: (state) => state.sourceOptions.map(source => ({
        label: source.sourceName,
        value: source.sourceName,
    })),
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/lessee.js